import { useRouterState } from '@tanstack/react-router'
import { useMemo } from 'react'
import type { BreadcrumbDefinition, RouteStaticData } from './breadcrumbs'

export function useBreadcrumbs(extra?: BreadcrumbDefinition[]) {
  const matches = useRouterState({
    select: (state) => state.matches,
  })

  return useMemo(() => {
    return matches
      .flatMap((match) => (match.staticData as RouteStaticData | undefined)?.breadcrumbs ?? [])
      .concat(extra ?? [])
  }, [matches, extra])
}
